import {LAYOUT_Z_INDEX} from '@/styles';

export const MAP_LAYER_Z_INDEX = {
  MAP_CURSOR: 50,
  MAP_FLOATING: 115,
  MAP_SIDEPANEL: LAYOUT_Z_INDEX.SIDE_PANEL,
  NEARBY_MARKER: 2,
  DATA_TILE: 2,
  CATEGORY_BRAND: 4,
  LOCATION: 15,
  RANKING_BLOCK: 15,
};
